import { render, staticRenderFns } from "./step-btns.vue?vue&type=template&id=80d7fdb8&scoped=true&"
import script from "./step-btns.vue?vue&type=script&lang=js&"
export * from "./step-btns.vue?vue&type=script&lang=js&"
import style0 from "./step-btns.vue?vue&type=style&index=0&id=80d7fdb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d7fdb8",
  null
  
)

export default component.exports